

module.exports = __webpack_require__.stylable.create(
    "TextButton551488241",
    {"classes":{"root":"TextButton551488241__root","rootColorless":"TextButton551488241__rootColorless"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    14,
    "TextButton551488241",
    null
);
